import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { systemSettingsApi } from '~/apis/systemSettingsApi'
import { useUserState } from '~/atoms/UserState'
import { toaster } from '~/components/ui/toaster'
import { useGetTimeZones } from '~/queries/timeZoneQueries'

import type { TimeZoneOption } from '@mangovoice/constants'
import { SystemSettingsPage } from '@mangovoice/system-settings-ui'

export const SystemSettingsSettingsPage = () => {
  const { t } = useTranslation()
  const { pbxId } = useUserState({ canAutoRefresh: false })

  const { data: apiTimeZones } = useGetTimeZones()
  const timeZoneOptions = useMemo<TimeZoneOption[] | undefined>(
    () =>
      apiTimeZones?.map((tz) => ({
        value: tz.iana_time_zone,
        label: tz.label,
      })),
    [apiTimeZones],
  )

  // Playlists (and other reference data) are fetched inside SystemSettingsPage
  // via its own PBX-scoped queries; that path carries track_count, which the
  // empty-playlist guard needs.
  return (
    <SystemSettingsPage
      api={systemSettingsApi}
      pbxId={pbxId}
      toast={toaster}
      t={t}
      timeZoneOptions={timeZoneOptions}
    />
  )
}
